module.exports = {"id":"234949","name":"João Amaral","rating":"73","photo":"./data/images/photos/4/234949.png","club":{"name":"Vitoria Setúbal","logo":"./data/images/clubs/VitoriaSetubal.png"},"positions":["MD","MOC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoaoAmaral0.json
// module id = 2027
// module chunks = 0